import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Computer = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="computer icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M10 14.2528L10.0383 6.96991L15.0333 12.2702L12.8227 12.1305L13.8937 14.376L12.673 14.9583L11.5529 12.6098L10 14.2528Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 19.9819H4C1.79086 19.9819 0 18.1911 0 15.9819V4.98193C0 2.77279 1.79086 0.981934 4 0.981934H20C22.2091 0.981934 24 2.77279 24 4.98193V15.9819C24 18.1911 22.2091 19.9819 20 19.9819H13.5V20.9819H16C16.5523 20.9819 17 21.4296 17 21.9819C17 22.5342 16.5523 22.9819 16 22.9819H8C7.44772 22.9819 7 22.5342 7 21.9819C7 21.4296 7.44772 20.9819 8 20.9819H10.5V19.9819ZM4 2.98193H20C21.1046 2.98193 22 3.87736 22 4.98193V15.9819C22 17.0865 21.1046 17.9819 20 17.9819H4C2.89543 17.9819 2 17.0865 2 15.9819V4.98193C2 3.87736 2.89543 2.98193 4 2.98193Z"
    />
  </svg>
)
